import ListDoubtsCandidates  from './ListDoubtsCandidates';

export default ListDoubtsCandidates ;
